var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isChile()
    ? _c("div", { attrs: { id: "consignments-content" } }, [
        _c(
          "div",
          { staticClass: "options mb-4" },
          [
            _c(
              "div",
              {
                staticClass:
                  "columns is-variable reverse-columns is-justify-content-space-between mb-0",
              },
              [
                _c("div", { staticClass: "column" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "is-align-items-center is-flex-desktop has-text-centered-mobile is-vcentered is-centered",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "button is-small is-button-secondary mr-2",
                          attrs: { id: "button-filter" },
                          on: {
                            click: function ($event) {
                              _vm.filterIsShowed = !_vm.filterIsShowed
                            },
                          },
                        },
                        [_vm._m(0), _c("span", [_vm._v("Filtrar")])]
                      ),
                      _c(
                        "button",
                        {
                          staticClass:
                            "button is-small is-button-secondary mr-2",
                          attrs: {
                            id: "button-excel",
                            disabled: !_vm.enableExcelButton,
                          },
                          on: { click: _vm.onClickExcelButton },
                        },
                        [_vm._m(1), _c("span", [_vm._v("Excel")])]
                      ),
                      _c(
                        "p",
                        {
                          staticClass: "message-result is-block-mobile",
                          attrs: { id: "filter-message" },
                        },
                        [_vm._v(_vm._s(_vm.messageResult))]
                      ),
                    ]
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "search column is-two-fifths-tablet is-two-fifths-desktop",
                  },
                  [
                    _c(
                      "b-field",
                      [
                        _c("b-input", {
                          staticClass: "is-primary",
                          attrs: {
                            id: "search-input",
                            type: "search",
                            icon: "search",
                            "icon-clickable": "",
                            disabled: !_vm.investors.length,
                            placeholder: "búsqueda",
                            size: "is-small",
                            title:
                              "Búsqueda en: identificador, creado por, total consignado, código CMF, identificador de cliente",
                          },
                          on: { blur: _vm.triggerFilter },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.triggerFilter.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.filters.searchInputValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.filters, "searchInputValue", $$v)
                            },
                            expression: "filters.searchInputValue",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
            _c("Transition", { attrs: { duration: "500", name: "fade" } }, [
              _vm.filterIsShowed
                ? _c(
                    "div",
                    {
                      staticClass: "filter mt-1",
                      attrs: { id: "filter-card" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "columns is-centered reverse-columns" },
                        [
                          _c(
                            "div",
                            { staticClass: "column is-one-third-desktop" },
                            [
                              _c(
                                "b-field",
                                { attrs: { label: "Rango de fechas" } },
                                [
                                  _c("b-datepicker", {
                                    staticClass: "test",
                                    attrs: {
                                      id: "date-filter",
                                      locale: "es-ES",
                                      placeholder: "Clic para seleccionar",
                                      icon: "calendar",
                                      "icon-pack": "fa",
                                      range: "",
                                      size: "is-small",
                                      "mobile-native": false,
                                      "trap-focus": "",
                                      "date-formatter": _vm.dateFormatter,
                                    },
                                    on: { input: _vm.triggerFilter },
                                    model: {
                                      value: _vm.dates,
                                      callback: function ($$v) {
                                        _vm.dates = $$v
                                      },
                                      expression: "dates",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("b-button", {
                                staticClass: "btn-clear",
                                attrs: {
                                  label: "Restaurar filtros",
                                  type: "is-default",
                                  "icon-left": "arrow-rotate-left",
                                  size: "is-small",
                                  outlined: "",
                                },
                                on: { click: _vm.restoreFilters },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "column is-half-desktop" },
                            [
                              _c(
                                "b-field",
                                {
                                  attrs: {
                                    label: "Vehículo de inversión",
                                    expanded: "",
                                  },
                                },
                                [
                                  _c("b-taginput", {
                                    attrs: {
                                      id: "consignment-filter-investor",
                                      "allow-new": false,
                                      "open-on-focus": true,
                                      field: "name",
                                      icon: "label",
                                      autocomplete: "",
                                      rounded: "",
                                      type: "is-info-light",
                                      size: "is-small",
                                      "has-counter": false,
                                      data: _vm.investorsOptions,
                                    },
                                    on: {
                                      input: _vm.triggerFilter,
                                      typing: _vm.filteredInvestorsOptions,
                                    },
                                    model: {
                                      value: _vm.filters.selectedInvestorId,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.filters,
                                          "selectedInvestorId",
                                          $$v
                                        )
                                      },
                                      expression: "filters.selectedInvestorId",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "fas fa-filter" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "far fa-file-excel" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }